'use client'

import { useEffect, useState } from 'react'

// Small-screen detection for responsive layouts (prototype ui.jsx:5-14).
// SSR-safe: defaults to false on the server, syncs in an effect on mount.
export function useIsMobile(bp = 760): boolean {
  const [mobile, setMobile] = useState(false)
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${bp}px)`)
    setMobile(mq.matches)
    const h = (e: MediaQueryListEvent) => setMobile(e.matches)
    mq.addEventListener('change', h)
    return () => mq.removeEventListener('change', h)
  }, [bp])
  return mobile
}
